/* eslint-disable jsx-a11y/control-has-associated-label */
import { useTranslation } from 'react-i18next';
import { Table, Checkbox } from 'react-bootstrap';
import { Property, PropertyBusinessType } from 'models/Properties';
import { PropertiesSelectTableContainer } from './PropertiesSelectTable.styles';

interface PropertiesSelectTableProps {
  properties: Property[];
  checkedProperties: Record<string, boolean>;
  allSelected: boolean;
  onSelectAll?: () => void;
  onPropertyToggle?: (uid: string, checked: boolean) => void;
  disabled?: boolean;
}

const PropertiesSelectTable = ({
  properties,
  checkedProperties,
  allSelected,
  onSelectAll,
  onPropertyToggle,
  disabled = false,
}: PropertiesSelectTableProps) => {
  const { t } = useTranslation();

  const formatPropertyName = (property: Property) => {
    if (property.businessType === PropertyBusinessType.HOTEL) {
      return t(
        'pageScreenAndProtect.detailsPage.propertiesSelectModal.list.hotel',
        { name: property.name },
      );
    }

    if (
      property.businessType === PropertyBusinessType.STANDALONE_PROPERTY &&
      property.numberOfSubUnits > 0
    ) {
      return t(
        'pageScreenAndProtect.detailsPage.propertiesSelectModal.list.master',
        { name: property.name },
      );
    }

    return property.name;
  };

  return (
    <PropertiesSelectTableContainer>
      {/* using react-bootstrap table instead of CommonTable with useTable because it's simpler and to avoid re-rendering issues */}
      <Table striped>
        <thead>
          <tr>
            <th>
              <Checkbox
                data-testid="select-all-properties"
                checked={allSelected}
                onChange={onSelectAll}
                disabled={disabled}
              />
            </th>
            <th>
              {t(
                'pageScreenAndProtect.detailsPage.propertiesSelectModal.tableTitle',
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {properties.map((property) => (
            <tr key={property.uid}>
              <td>
                <Checkbox
                  data-testid={`property-checkbox-${property.uid}`}
                  checked={!!checkedProperties[property.uid]}
                  disabled={disabled}
                  onChange={(e) => {
                    onPropertyToggle?.(
                      property.uid,
                      (e.target as HTMLInputElement).checked,
                    );
                  }}
                />
              </td>
              <td>{formatPropertyName(property)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PropertiesSelectTableContainer>
  );
};

PropertiesSelectTable.defaultProps = {
  onSelectAll: () => {},
  onPropertyToggle: () => {},
  disabled: false,
};

export default PropertiesSelectTable;
